stencil-route.inactive {
  display: none;
}
